import { render, staticRenderFns } from "./MinimalDocumentManagement.vue?vue&type=template&id=cf9476ee&scoped=true&"
import script from "./MinimalDocumentManagement.vue?vue&type=script&lang=js&"
export * from "./MinimalDocumentManagement.vue?vue&type=script&lang=js&"
import style0 from "./MinimalDocumentManagement.vue?vue&type=style&index=0&id=cf9476ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf9476ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf9476ee')) {
      api.createRecord('cf9476ee', component.options)
    } else {
      api.reload('cf9476ee', component.options)
    }
    module.hot.accept("./MinimalDocumentManagement.vue?vue&type=template&id=cf9476ee&scoped=true&", function () {
      api.rerender('cf9476ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/vistas/empresas/72235100-2/components/MinimalDocumentManagement.vue"
export default component.exports